import React, { useContext, useState } from "react";
import withAuth from "../utils/withAuth";
import { useNavigate } from "react-router-dom";
import "../App.css";

import { Button, IconButton, TextField } from "@mui/material";
import RestoreIcon from "@mui/icons-material/Restore";
import { AuthContext } from "../contexts/AuthContext";

function HomeComponent() {
    const navigate = useNavigate();
    const [meetingCode, setMeetingCode] = useState("");

    const { addToUserHistory } = useContext(AuthContext);

    const handleJoinVideoCall = async () => {
        if (!meetingCode.trim()) {
            return;
        }

        await addToUserHistory(meetingCode);
        navigate(`/${meetingCode}`);
    };

    const handleHistory = () => {
        navigate("/history");
    };

    const handleLogout = () => {
        localStorage.removeItem("token");
        navigate("/auth");
    };

    return (
        <div className="homePage">

            {/* NAVBAR */}
            <div className="navBar">

                <div className="brand">
                    <h2>Apna Video Call</h2>
                </div>

                <div className="navActions">

                    {/* HISTORY */}
                    <button
                        className="historyButton"
                        onClick={handleHistory}
                    >
                        <IconButton>
                            <RestoreIcon />
                        </IconButton>

                        <span>History</span>
                    </button>

                    {/* LOGOUT */}
                    <Button
                        className="logoutButton"
                        onClick={handleLogout}
                    >
                        Logout
                    </Button>

                </div>

            </div>


            {/* MAIN CONTENT */}
            <div className="meetContainer">

                {/* LEFT */}
                <div className="leftPanel">

                    <div className="homeContent">

                        <div className="badge">
                            🎥 Secure Video Meetings
                        </div>

                        <h1>
                            Providing Quality Video Call
                            <br />
                            Just Like Quality Education
                        </h1>

                        <p className="homeSubtitle">
                            Connect with your friends, classmates and
                            colleagues instantly with a simple meeting code.
                        </p>

                        {/* JOIN BOX */}
                        <div className="joinBox">

                            <TextField
                                value={meetingCode}
                                onChange={(e) =>
                                    setMeetingCode(e.target.value)
                                }
                                label="Meeting Code"
                                placeholder="Enter meeting code"
                                variant="outlined"
                                fullWidth
                                className="meetingInput"
                            />

                            <Button
                                onClick={handleJoinVideoCall}
                                variant="contained"
                                className="joinButton"
                            >
                                JOIN
                            </Button>

                        </div>

                    </div>

                </div>


                {/* RIGHT */}
                <div className="rightPanel">

                    <div className="videoCard">

                        <img
                            src="/logo3.png"
                            alt="Video conference"
                        />

                    </div>

                </div>

            </div>

        </div>
    );
}

export default withAuth(HomeComponent);